<template>
  <el-dialog :visible.sync="visiable">
    <!-- <iframe src="7-B授权委托书（单位-经办)通用勾选版20220111.pdf" allowtransparency="yes" width="100%" height="850" scrolling="no" frameborder="0"></iframe> -->
    <div class="argument">
        <h3>授权委托书</h3>
        <div class="text">
            <h4>致：上海市数字证书中心有限公司</h4>
            <p>委托单位现委托本页面列明之受委托人，以委托单位名义在上海市数字证书认证中心有限公司运营的“法人一证通”平台（以下简称“平台”）办理所有事务，包括不限于：委托单位的身份认证、法人一证通申领与使用、电子印章生成与使用、法人一证通与电子印章的授权管理、法人一证通与电子印章的管理等。</p>
            <p>委托单位认可：（1）受委托人在平台的任何操作均视为委托单位的行为，委托单位对此不持任何异议。受委托人在平台的操作行为均对委托单位发生法律效力；（2）受委托人有权转授权，届时由受委托人操作即可，委托单位无需另行出具授权或类似同意文件，委托单位对受委托人的转授权行为均予认可。转授权后的被授权人之行为法律效力仍及于委托单位。</p>
            <p>委托单位承诺：（1）已将以下事项明确告知受委托人并已取得其授权同意：委托单位将获取其个人信息并向平台提供，平台获取后有权将该等个人信息用以核实受委托人真实身份；（2）使用平台服务应遵照国家法律法规、政策、平台的服务协议，且不侵犯第三人的合法权益；（3）受委托人以委托单位名义提交的所有材料真实、准确、完整、有效，如有任何材料变更或补正，应及时书面告知。如材料虚假、错误、遗漏或失效，平台有权中止或终止服务；（4）若委托单位变更受委托人，应重新出具变更说明及更新后的授权委托书。如违反上述任何承诺，委托单位自行承担由此产生的一切责任。</p>
            <p>本委托书采取线下签署或者在线上进行点击、打勾、确认等表示同意的动作予以签署（具体签署形式以平台要求为准），委托书自签署日生效，直至委托单位书面通知上海市数字证书中心有限公司撤销本委托。</p>
        </div>
        <el-button style="margin-top: 15px" @click="visiable=false" type="warning">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visiable: false,
    };
  },
  methods: {
    show() {
      this.visiable = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.argument{
    text-align: center;
    .text{
        text-align: left;
        line-height: 28px;
        p{
            text-indent: 0.8cm;
        }
    }
}
</style>